export const capitalize = (value) => {
	if (!value) return ''
	value = value.toString()
	return typeof value === 'string' ? value.charAt(0).toUpperCase() + value.slice(1) : value;
};
